import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition';
import CommentCard from '../components/CommentCard';
// CSS
import '../assets/css/blog.css'

export default function Blog() {
  const [sideContentShow, setSideContentShow] = useState(false);
  const [data, setData] = useState({
    thumbnail:"https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60",
    title:"Fashion Trends",
    description:[
      {type: 'description', text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras non placerat mi. Etiam non tellus sem. Aenean pretium convallis lorem, sit amet dapibus ante mollis a. Integer bibendum interdum sem, eget volutpat purus pulvinar in"}, 

      {type: 'quote', text:"“Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model search for evolved over sometimes by accident, sometimes on purpose “"}, 

      {type: 'description', text:"Aenean lorem diam, venenatis nec venenatis id, adipiscing ac massa. Nam vel dui eget justo dictum pretium a rhoncus ipsum. Donec venenatis erat tincidunt nunc suscipit, sit amet bibendum lacus posuere. Sed scelerisque, dolor a pharetra sodales, mi augue consequat sapien, et interdum tellus leo et nunc. Nunc imperdiet eu libero ut imperdiet."}],
    date:"SEPTEMBER 30, 2019",
    author:"Joe Doe",
    categories:[{name: 'Lifestyle', link: 'lifestyle'}, {name: 'Men', link: 'Mens'}],
    likes:12
  })

  const [comments, setComments] = useState([
    {
      name: 'John Doe',
      image: 'https://via.placeholder.com/150',
      createdAt: 'September 24, 2020',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
      commentId: '1',
      parentId: null
    },
    {
      name: 'John Doe',
      image: 'https://via.placeholder.com/150',
      createdAt: 'September 24, 2020',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
      commentId: '2',
      parentId: null
    },
    {
      name: 'John Doe',
      image: 'https://via.placeholder.com/150',
      createdAt: 'September 24, 2020',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
      commentId: '3',
      parentId: '1'
    },
    {
      name: 'John Doe',
      image: 'https://via.placeholder.com/150',
      createdAt: 'September 24, 2020',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
      commentId: '4',
      parentId: '1'
    },
    {
      name: 'John Doe',
      image: 'https://via.placeholder.com/150',
      createdAt: 'September 24, 2020',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
      commentId: '5',
      parentId: '2'
    },
    {
      name: 'John Doe',
      image: 'https://via.placeholder.com/150',
      createdAt: 'September 24, 2020',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.',
      commentId: '6',
      parentId: '3'
    },
  ]);

  const rootComments = comments.filter(comment => comment.parentId === null);

  const getReplies = commentId => {
    return comments.filter(comment => comment.parentId === commentId);
  }

  const addComment = event => {
    event.preventDefault();

    const comment = {
      name: 'Forhad Hossain',
      image: 'https://via.placeholder.com/150',
      createdAt: 'September 24, 2020',
      text: event.target.comment_text.value,
      commentId: comments[comments.length - 1].commentId + 1,
      parentId: null
    }

    setComments([...comments, comment]);
  }

  return (
    <div className='blog_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path: '/', active: false}, {name: 'Blogs', path: '/blogs', active: false}, {name: 'Fation Trends', path: '/fashio-trends', active: true}]} pageName='Fation Trends' />

      <div className='container'>
        <div className='left'>
          <div className='thumbnail'>
            <img src={data.thumbnail} alt='blog' />
          </div>
          <div className='details'>
            <div className='title'>{data.title}</div>
            <div className='infos'>
              <a>{data.date}</a><p>|</p><Link to='/blogs/author/joe-doe'>{data.author}</Link><p>|</p> {
                data.categories.map((category, index) => {
                  if(index === data.categories.length - 1) {
                    return (
                      <Link key={index} to={'/blogs/category/'+category.link}>{category.name}</Link>
                    )
                  }
                  else{
                    return (
                      <>
                        <Link key={index} to={'/blogs/category/'+category.link}>{category.name}</Link>
                        <span>, </span>
                      </>
                    )
                  }
                })
              }
              <p>|</p><a><span className='fas fa-heart'></span> (10)</a>
            </div>
            <div className='description'>
              {
                data.description.map((item, index) => {
                  if(item.type === 'description'){
                    return (
                      <p key={index}>{item.text}</p>
                    )
                  }
                  else{
                    return (
                      <blockquote key={index}>
                        <p>{item.text}</p>
                      </blockquote>
                    )
                  }
                })
              }
            </div>
          </div>

          <div className='comments'>
            <div className='section_title'>Comments (02)</div>

            <div className='content'>
              {
                rootComments.map((comment, index) => {
                  return(
                    <CommentCard key={index} comment={comment} canReply={true} topParent={comment.commentId} replies={getReplies(comment.commentId)} />
                  )
                })
              }
            </div>

            <form className='add_comment_form default' style={{marginTop: '30px'}} onSubmit={addComment}>
              <div className='form_header'>
                <div className='title'>Add a comment</div>
              </div>
              <div className='inputs'>
                <div className='input_container'>
                  <textarea style={{height: '80px'}} placeholder='Write your comment here...' name='comment_text' required></textarea>
                </div>
              </div>
              <div className='actions'>
                <button className='submit_btn'>Post Comment</button>
              </div>
            </form>
          </div>
        </div>

        <div className={sideContentShow? 'right show' : 'right'}>
          <div className='right_section_toggle_btn' onClick={() => {setSideContentShow(!sideContentShow)}}>
            <span className='fas fa-sliders-h'></span>
          </div>
          <section className='about'>
            <div className='section_title'>About The Blog</div>

            <div className='content'>
              <p>Lorem ipsum dolor sit amet, consectetur elit porta. Vestibulum ante justo, volutpat quis porta diam.</p>
            </div>
          </section>

          <section className='search'>
            <div className='content'>
              <form className='search_form'>
                <div className='input_container'>
                  <input type='text' placeholder='Search' />
                  <button className='fas fa-search'></button>
                </div>
              </form>
            </div>
          </section>

          <section className='recent_posts'>
            <div className='section_title'>Recent Posts</div>

            <div className='content'>
              <div className='item'>
                <span>SEPTEMBER 30, 2019</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>SEPTEMBER 30, 2019</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>SEPTEMBER 30, 2019</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
            </div>
          </section>

          <section className='recent_comments'>
            <div className='section_title'>Recent Comments</div>

            <div className='content'>
              <div className='item'>
                <span>Alex on</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>Alex on</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
              <div className='item'>
                <span>Alex on</span>
                <Link to='/blogs/post'>Fation Trends</Link>
              </div>
            </div>
          </section>

          <section className='categories'>
            <div className='section_title'>Categories</div>

            <div className='content'>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (02)</Link>
                <div className='sub_item'>
                  <Link to='/blogs/category/lifestyle/1'>Lifestyle (01)</Link>
                  <Link to='/blogs/category/lifestyle/2'>Lifestyle (12)</Link>
                </div>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (22)</Link>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (09)</Link>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Lifestyle (0)</Link>
              </div>
              <div className='item'>
                <Link to='/blogs/category/lifestyle'>Uncategorised (02)</Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}
